<template>

    <div class="w-full font-sans">


        <nav class="nav flex flex-wrap fixed w-full items-center justify-between px-4 bg-white pr-0 md:pr-6">
  <div class="flex flex-no-shrink items-center mr-6 py-3 text-blue-900 cursor-pointer" @click="goto('home')">
    <img class="fill-current h-8 mr-2 w-8" alt="GCIOSA logo" src="../../images/gciosa.png" >
    <span class="font-semibold text-xl tracking-tight">GCIOSA</span>
  </div>

  <input class="menu-btn hidden" type="checkbox" id="menu-btn">
  <label class="menu-icon block cursor-pointer md:hidden  mr-4  px-2 py-4 relative select-none" for="menu-btn">
    <span class="navicon bg-grey-darkest flex items-center relative"></span>
  </label>

  <ul class="menu border-b md:border-none flex justify-end list-reset m-0 w-full md:w-auto">
    <li class="border-t md:border-none cursor-pointer hover:font-medium hover:text-xl hover:bg-blue-200 rounded" @click="goto('announcements')">
      <a class="block md:inline-block px-4 py-2 no-underline text-grey-darkest hover:text-grey-darker">Announcements</a>
    </li>
    
    <li class="border-t md:border-none cursor-pointer hover:font-medium hover:text-xl hover:bg-blue-200 rounded" @click="goto('gallery')">
      <a class="block md:inline-block px-4 py-2 no-underline text-grey-darkest hover:text-grey-darker">Gallery</a>
    </li>

    

    <li class="border-t md:border-none cursor-pointer hover:font-medium hover:text-xl hover:bg-blue-200 rounded" @click="goto('contact')">
      <a class="block md:inline-block px-4 py-2 no-underline text-grey-darkest hover:text-grey-darker">Enquiry</a>
    </li>
    
    <li class="border-t md:border-none cursor-pointer hover:font-medium hover:text-xl hover:bg-blue-200 rounded" @click="goToInfo">
      <a class="block md:inline-block px-4 py-2 no-underline text-grey-darkest hover:text-grey-darker">My Info</a>
    </li>

    <li class="border-t md:border-none cursor-pointer hover:font-medium hover:text-xl hover:bg-blue-200 rounded" @click="goToUserSearch">
        <a class="block md:inline-block px-4 py-2 no-underline text-grey-darkest hover:text-grey-darker">Search for members</a>
    </li>

    <li class="border-t md:border-none cursor-pointer hover:font-medium hover:text-xl hover:bg-red-700 rounded text-red-700 hover:text-white" @click="logout">
      <a class="block md:inline-block px-4 py-2 no-underline">Logout</a>
    </li>

    
    
  </ul>
</nav>




        <!--    nav-bar-->
        <!-- <div class="flex flex-wrap w-full justify-center md:justify-between items-center
        py-3 bg-white" style="opacity: 0.9">
            <div class="flex ml-0 md:ml-6 cursor-pointer pr-4 items-center">
                <img class="h-10 w-10"  alt="school logo" src="../../images/gciosa.png" >
                <span class="ml-1 text-xl text-white text-blue-900 font-semibold invisible md:visible">GCIOSA</span>
            </div>
            <ul class="md:flex sm:block mt-6 md:mt-0 ml-6 md:ml-0 overflow-x-auto mr-10 font-semibold pt-0 md:pt-2">

                <li class="mr-6 mb-2 px-4 py-1 bg-white border-blue-900 hover:bg-blue-900 rounded-lg text-blue-900 hover:text-white " style="border-width: 1px" @click="goto('announcements')">
                    <a class="text-sm">Announcements</a>
                </li>
                <li class="mr-6 mb-2 px-4 py-1 bg-white border-blue-900 hover:bg-blue-900 rounded-lg text-blue-900 hover:text-white" style="border-width: 1px" @click="goto('gallery')" >
                    <a class="text-sm">Photo Gallery</a>
                </li>

                <li class="mr-6 mb-2 px-4 py-1 bg-white border-blue-900 hover:bg-blue-900 rounded-lg text-blue-900 hover:text-white " style="border-width: 1px" @click="goto('contact')">
                    <a class="text-sm">Enquiry</a>
                </li>

                <li class="mr-6 mb-2 px-4 py-1 bg-white border-blue-900 hover:bg-blue-900 rounded-lg text-blue-900 hover:text-white" style="border-width: 1px" @click="goToInfo">
                    <a class="text-sm">My Info</a>
                </li>

                <li class="mr-6 mb-2 px-4 py-1 bg-white border-red-900 hover:bg-red-900 rounded-lg text-red-900 hover:text-white" style="border-width: 1px" @click="logout">
                    <a class="text-sm">Logout</a>
                </li>

            </ul>
        </div> -->

<!--        header-->

        <div ref="home" class="flex w-full h-screen bg-img">
            <div class="flex w-full h-screen items-center justify-center bg-gray-900 bg-opacity-50 pt-20">
                <div class="flex-wrap text-center text-white px-6">
                    <h1 class="font-sans text-4xl font-semibold tracking-wider leading-tight">Government College Ikorodu Old Students' Association</h1>
                    <h2 class="font-light text-2xl font-normal tracking-wide leading-tight mt-3 mb-4">This is our Association and together, we shall establish it.</h2>

                </div>
                 </div>
        </div>


        
<!--        announcements-->
        <div ref="announcements">
            <announcement></announcement>
        </div>
<!--        photo gallery-->
        <div ref="gallery">
            <photo-gallery></photo-gallery>
        </div>

        <div ref="search">
            <!-- <users></users> -->
        </div>

        <div ref="contact" class="w-full bg-blue-900">
            <div class="flex flex-wrap justify-center text-center text-white">
                <div class="w-full md:w-1/3 p-5">
                    <div class="my-6 text-xl font-semibold">CONTACT US</div>
                    <p class="mt-8 text-gray-400">
                        A108 Adam Street <br>
                        New York, NY 535022 <br>
                        United States <br>
                        <strong>Phone:</strong> +1 5589 55488 55 <br>
                        <strong>Email:</strong> info@webcraft.com
                    </p>
                    <div class="relative w-20 h-20 mx-auto my-12 bg-blue-300 rotate-45">
                        <div class="flex justify-center items-center absolute left-0 top-0 w-10 h-10 hover:-ml-1 hover:-mt-1 bg-blue-800 cursor-pointer">
                            <FacebookIcon  class="text-blue-500 -rotate-45"></FacebookIcon>
                        </div>
                        <div class="flex justify-center items-center absolute top-0 right-0 w-10 h-10 hover:-mt-1 hover:-mr-1 bg-blue-800 cursor-pointer">
                            <TwitterIcon class="text-blue-500 -rotate-45"></TwitterIcon>
                        </div>
                        <div class="flex justify-center items-center absolute right-0 bottom-0 w-10 h-10 hover:-mr-1 hover:-mb-1 bg-blue-800 cursor-pointer">
                            <MailIcon class="text-blue-500 -rotate-45"></MailIcon>
                        </div>
                        <div class="flex justify-center items-center absolute bottom-0 left-0 w-10 h-10 hover:-mb-1 hover:-ml-1 bg-blue-800 cursor-pointer">
                            <InstagramIcon class="text-blue-500 -rotate-45"></InstagramIcon>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <div>
            <slider></slider>
        </div>



    </div>

</template>

<script>
    // import router from "../../js/routes";
    import PhotoGallery from "./PhotoGallery";
    import Announcement from "./Announcement";
    // import Users from "../user/Users";
    import {InstagramIcon, FacebookIcon, TwitterIcon, MailIcon} from 'vue-feather-icons';
    import slider from "./slider";

    export default {
        name: "Home",
        components: {PhotoGallery, Announcement,  InstagramIcon, FacebookIcon, TwitterIcon, MailIcon, slider},
        data: function(){
            return {

            }
        },
        methods: {
            logout: function(){
                localStorage.clear();
                this.$router.push('/');
            },

            goto(refName) {
               
                let element = this.$refs[refName];
                // console.log(element);
                element.scrollIntoView({behavior: "smooth", block: "end"});
            },

            goToInfo(){
                this.$router.push('/acct');
            },
             
            goToUserSearch(){
                this.$router.push('/users');
            }
        }

    }
</script>

<style scoped>
    .rotate-45 {
        transform: rotate(45deg);
    }
    .-rotate-45 {
        transform: rotate(-45deg);
    }

    .bg-img{
        background-image: url("../../images/students.jpeg");
        background-size: cover;


    }


    /* navbar */

    @media (max-width: 767px) {
        .navicon {
            width: 1.125em;
            height: .125em;
        }

        .navicon::before,
        .navicon::after {
            display: block;
            position: absolute;
            width: 100%;
            height: 100%;
            transition: all .2s ease-out;
            content: '';
            background: #3D4852;
        }

        .navicon::before {
            top: 5px;
        }

        .navicon::after {
            top: -5px;
        }

        .menu-btn:not(:checked) ~ .menu {
            display: none;
        }

        .menu-btn:checked ~ .menu {
            display: block;
        }

        .menu-btn:checked ~ .menu-icon .navicon {
            background: transparent;
            
        }

        .menu-btn:not(:checked) ~ .menu-icon .navicon {
            background: #3D4852;
            
        }

        .menu-btn:checked ~ .menu-icon .navicon::before {
            transform: rotate(-45deg);
        }

        .menu-btn:checked ~ .menu-icon .navicon::after {
            transform: rotate(45deg);
        }

        .menu-btn:checked ~ .menu-icon .navicon::before,
        .menu-btn:checked ~ .menu-icon .navicon::after {
            top: 0;
        }
    }
</style>
